/* GreenIT V3.2 — place the Icon/logo row sections (payment + benefits) at the
   bottom of the middle column (.custom_middle_part), under the Selleasy bundle.
   Sections still edit normally in the theme editor; this only changes where they
   render on the storefront. */
(function () {
  if (window.__giMoveInit) return;
  window.__giMoveInit = true;

  function run() {
    var h = document.querySelector('.custom_middle_part');
    if (!h) return;
    var secs = document.querySelectorAll('.gi-iconrow-section');
    for (var i = 0; i < secs.length; i++) {
      secs[i].classList.add('gi-moved');
      if (secs[i].parentNode !== h) h.appendChild(secs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  var tries = 0;
  var iv = setInterval(function () { run(); if (++tries > 8) clearInterval(iv); }, 500);
})();
